import BasicInfo from './BasicInfo';
import ChildInfo from './ChildInfo';
import ElectronicDelivery from './ElectronicDelivery';
import Eligibility from './Eligibility';
import FiveYearEiligibility from './FiveYearEiligibility';
import GettingStarted from './GettingStarted';
import HIVEligibility from './HIVEligibility';
import ImportantBenifits from './ImportantBenifits';
import Ineligibility from './Ineligibility';
import InsuredInfo from './InsuredInfo';
import MedicalEligibility from './MedicalEligibility';
import PaymentInfo from './PaymentInfo';
import Quoter from './Quoter';
import ReplacingInfo from './ReplacingInfo';
import SevenYearEligibility from './SevenYearEligibility';
import SplashPage from './SplashPage';
import SpouseInfo from './SpouseInfo';
import SubmissionReview from './SubmissionReview';
import ThreeYearEligibility from './ThreeYearEligibility';
import ThirdPartyDemoGraphic from './ThirdPartyDemoGraphic';
import Beneficiary from './Beneficiary';
import DocuSign from './DocuSign';

export {
    BasicInfo,
    ChildInfo,
    ElectronicDelivery,
    Eligibility,
    FiveYearEiligibility,
    GettingStarted,
    HIVEligibility,
    ImportantBenifits,
    Ineligibility,
    InsuredInfo,
    MedicalEligibility,
    PaymentInfo,
    Quoter,
    ReplacingInfo,
    SevenYearEligibility,
    SplashPage,
    SpouseInfo,
    SubmissionReview,
    ThreeYearEligibility,
    ThirdPartyDemoGraphic,
    Beneficiary,
    DocuSign
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/index.js